var m = require('mithril');
var button = require('../../components/button.js');

module.exports = function actions (ctrl, model) {
  if (model.actions) {
    var visibleActions = model.actions.filter(function (action) {
      return typeof action.visible !== 'function' || action.visible(ctrl);
    });
    return m('div.cf', visibleActions.map(function (action) {
      return m('div.fl.w-100.w-50-ns.w-25-l.ph3.f6.mv2', [
          m(button, {
            label: action.name,
            class: "",
            func: action.func.bind(null, ctrl)
          })
        ])
    }))
  }
};
